import React from 'react';
import { MainLayout } from '../../components/layout';
import UserList from './UserList';

const UserManagement: React.FC = () => {
  return (
    <MainLayout title="账号管理">
      <UserList />
    </MainLayout>
  );
};

export default UserManagement;
